// Следующий шаг у письма, которое ждёт или не ушло (008: FR-018; 033: FR-008; 035: T027, сценарий 1.8,
// принцип XIV): шаг по коду причины — из каталога ошибок, под стоп-краном — где «Возобновить».
// Общие для карточки письма (LetterCard.tsx) и строки приветственного письма (users/welcome-letter.tsx):
// отдельный файл, чтобы окно пользователя не тянуло за собой карточку письма.
import { errorCatalog, isErrorCode } from '@kp/contracts';

/** Шаг по коду причины из каталога ошибок (MAIL-0xx); незнакомый код — без шага. */
export function reasonStep(code: string): string | null {
  return isErrorCode(code) ? errorCatalog[code].nextStep : null;
}

/** Где возобновить сообщения: полоса вверху экрана или «Настройки → Рассылка» (033, FR-008). */
export const STOPPED_STEP =
  'Письмо уйдёт после «Возобновить» — в полосе вверху экрана или в «Настройки → Рассылка»';
